<div class="altcha-verification">
  @if (status === 'loading') {
  <div class="altcha-status" role="status">
    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <span>{{ "CAPTCHA.LOADING" | translate }}</span>
  </div>
  } @if (status === 'error') {
  <div class="altcha-status altcha-status--error" role="alert">
    <span>{{ "CAPTCHA.LOAD_ERROR" | translate }}</span>
    <button type="button" class="altcha-retry" (click)="retry()">
      {{ "CAPTCHA.RETRY" | translate }}
    </button>
  </div>
  }

  <altcha-widget
    #widget
    [class.altcha-widget--visible]="status === 'ready'"
  ></altcha-widget>
</div>
